console.log("app.js: loaded");
export class App {
  constructor() {
    console.log("App initialized");
  }
}

export function sum(a, b) {
  return a + b;
}
